<template>
  <ValidationObserver ref="observer">

    <ValidationProvider
      name="first_name"
      ref="firstNameProvider"
      rules="max:255"
      v-slot="{ errors }"
    >
      <v-text-field
        :error-messages="errors"
        class="mr-md-3"
        label="Имя"
        :prepend-icon="icons.mdiCardTextOutline"
        name="first_name"
        type="text"
        v-model="first_name"
      ></v-text-field>
    </ValidationProvider>

    <ValidationProvider
      name="last_name"
      ref="lastNameProvider"
      rules="max:255"
      v-slot="{ errors }"
    >
      <v-text-field
        :error-messages="errors"
        class="mr-md-3"
        label="Фамилия"
        :prepend-icon="icons.mdiCardTextOutline"
        name="last_name"
        type="text"
        v-model="last_name"
      ></v-text-field>
    </ValidationProvider>

    <ValidationProvider
      name="middle_name"
      ref="middleNameProvider"
      rules="max:255"
      v-slot="{ errors }"
    >
      <v-text-field
        :error-messages="errors"
        class="mr-md-3"
        label="Отчество"
        :prepend-icon="icons.mdiCardTextOutline"
        name="middle_name"
        type="text"
        v-model="middle_name"
      ></v-text-field>
    </ValidationProvider>

  </ValidationObserver>
</template>

<script>
  import {mapGetters} from "vuex";
  import {mdiCardTextOutline} from '@mdi/js'
  import {extend, localize, ValidationObserver, ValidationProvider} from "vee-validate";
  import {max} from "vee-validate/dist/rules";

  export default {
    name: "EgeDiffForm",
    components: {
      ValidationProvider,
      ValidationObserver
    },
    props: {
      validate: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        icons: {
          mdiCardTextOutline,
        },
        first_name: '',
        last_name: '',
        middle_name: '',
        isSuccess: true,
      }
    },
    mounted() {
      this.$store.dispatch("abiturient/loadAbiturient")
        .then(() => {
          this.first_name = this.abiturient.ege_first_name
          this.last_name = this.abiturient.ege_last_name
          this.middle_name = this.abiturient.ege_middle_name
        })
    },

    computed: {
      ...mapGetters("abiturient", ["abiturient"]),
      ...mapGetters("context", [
        'isLoading',
        'messages',
      ])
    },
    watch: {
      first_name(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {ege_first_name: value})
      },
      last_name(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {ege_last_name: value})
      },
      middle_name(value) {
        this.$store.commit("abiturient/UPDATE_ABITURIENT_MODEL", {ege_middle_name: value})
      },
    },
    methods: {
      async submit() {
        if (this.validate) {
          this.isSuccess = false
          const valid = await this.$refs.observer.validate()

          if (valid) {
            this.$store.commit("context/CLEAR_MESSAGES");
            await this.$store.dispatch("abiturient/update")
              .then(() => {
                if (this.messages) {
                  this.$refs.observer.setErrors(this.messages);
                } else {
                  this.isSuccess = true
                }
              })
          }
        }
        return this.isSuccess
      },
    }
  }

  localize({
    ru: {
      names: {
        first_name: ' ',
        last_name: ' ',
        middle_name: ' ',
      }
    }
  });
  extend('max', {
    ...max
  });
</script>

